import { createAction } from 'Lib/reduxUtils';

import {
  CONNECT_GOOGLE,
  CONNECT_LINE,
  DISCONNECT_GOOGLE,
  DISCONNECT_LINE,
  GET_LINE_ACCESS_TOKEN,
} from './constants';

export const connectGoogle = createAction(CONNECT_GOOGLE, (googleIdToken: string) => ({
  googleIdToken,
}));
export const disconnectGoogle = createAction(DISCONNECT_GOOGLE);

export const getLineAccessToken = createAction(
  GET_LINE_ACCESS_TOKEN,
  (clientId: string, connectAccountRequest: boolean) => ({
    clientId,
    connectAccountRequest,
  })
);

export const submitLineTokenConnectAccount = createAction(
  CONNECT_LINE,
  (lineToken: string, clientId: string) => ({
    lineToken,
    clientId,
  })
);

export const disconnectLine = createAction(DISCONNECT_LINE);
